import React, { Component, Fragment } from 'react';
import withStyles from '@mui/styles/withStyles';
import { withRouter } from '../../../util/withRouter';
import Grid from '../../../component/form/Grid';
import LinkButton from '../../../component/form/LinkButton';
import { getRequiredDocuments, getSignedArrangementFormForDocument } from './CertificationConstants';
import { isRelatedObjectDefined } from '../../../util/bookable';
import { applyUrlParams, stringIsNullOrEmpty } from '../../../util/strings';
import Table, { TableCell, TableRow } from '../../../component/form/Table';
import cx from 'classnames';
import FileUpload, { getFileName, uploadFilesQuery } from '../../../component/form/FileUpload';
import { compose } from '../../../reactApolloCompat';
import { getAssetsClient } from '../../../apollo';
import { setSnackbarMessage } from '../../../context/SnackbarMessage';
import { ExclamationCircleIcon, ExclamationTriangleIcon, TickCircleIcon } from '../../../component/IconIndex';
import Tooltip from '../../../component/form/Tooltip';
import Spinner from '../../../component/Spinner';

class CertificationTable extends Component {
    state = {
        isDragOverRow: {}
    };

    render() {
        const { form } = this.props;
        const requiredDocuments = getRequiredDocuments(form);

        return (
            <Grid pc={1}>
                <Table
                    className="no-responsive"
                    rowDragDrop={(file, index) => this.handleFileDrop(file, index)}
                    columns={['Status', 'Document Name', /*'Generated',*/ 'Filename', 'Upload']}
                >
                    {requiredDocuments.map((x, i) => this.renderRequiredDocument(x, i))}
                </Table>
            </Grid>
        );
    }

    renderRequiredDocument(requiredDocument, index) {
        const { form, classes, match, locked } = this.props;
        const file = form.getField(requiredDocument.fieldName) || {
            ID: null,
            AbsoluteLink: null,
            Name: null,
            Size: 0
        };
        const arrangementForm =
            1 < 2
                ? false
                : getSignedArrangementFormForDocument(form, requiredDocument.fieldName, requiredDocument.formType);
        return (
            <TableRow
                className={this.state.isDragOverRow[index] && classes.dragRow}
                key={index}
                onDragOver={event => this.handleRowDragOver(event, index)}
                onDragLeave={event => this.handleRowDragLeave(event, index)}
                onDrop={event => this.handleRowDragDrop(event, requiredDocument)}
            >
                <TableCell tiny>
                    {stringIsNullOrEmpty(file.AbsoluteLink) /*&& stringIsNullOrEmpty(arrangementForm.PDF)*/ ? (
                        <Tooltip title="Documentation is missing, please upload.">
                            <div className={cx(classes.iconContainer, classes.error)}>
                                <ExclamationCircleIcon />
                            </div>
                        </Tooltip>
                    ) : isRelatedObjectDefined(file.RequiredDocument) && 'Rejected' === file.RequiredDocument.Status ? (
                        <Tooltip title="Documentation is rejected, please replace.">
                            <div className={cx(classes.iconContainer, classes.warning)}>
                                <ExclamationTriangleIcon />
                            </div>
                        </Tooltip>
                    ) : (
                        <Tooltip title="Documentation is ok.">
                            <div className={cx(classes.iconContainer, classes.green)}>
                                <TickCircleIcon />
                            </div>
                        </Tooltip>
                    )}
                </TableCell>
                <TableCell>
                    {(1 > 2 && arrangementForm && (
                        <LinkButton
                            text={requiredDocument.description}
                            href={applyUrlParams(arrangementForm.formLink, match.params) || undefined}
                        />
                    )) ||
                        requiredDocument.description}
                </TableCell>
                {this.state.isDragOverRow[index] ? (
                    <TableCell colSpan={/*5*/ 2}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>Drop your file here to upload.</span>
                            <FileUpload disabled iconOnly />
                        </div>
                    </TableCell>
                ) : (
                    <Fragment>
                        {/*<TableCell>
                            {(arrangementForm.PDF && (
                                <LinkButton text={`View PDF`} href={arrangementForm.PDF.AbsoluteLink} target="blank" />
                            )) || '-'}
                        </TableCell>*/}
                        <TableCell>
                            {(file.Name && <LinkButton text={file.Name} href={file.AbsoluteLink} target="blank" />) ||
                                '-'}
                        </TableCell>
                        <TableCell tiny>
                            <div className={classes.uploadButtonContainer}>
                                <FileUpload
                                    disabled={locked}
                                    iconOnly
                                    folderPath={`/documents/funeral/${form.getField('ID')}`}
                                    onComplete={({ uploadFile }) =>
                                        this.onFileUploaded(uploadFile, requiredDocument.fieldName)
                                    }
                                />
                            </div>
                        </TableCell>
                    </Fragment>
                )}
            </TableRow>
        );
    }

    handleRowDragOver(event, index) {
        if (event && event.dataTransfer && event.dataTransfer.types && event.dataTransfer.types.includes('Files')) {
            event.stopPropagation();
            event.preventDefault();
            event.dataTransfer.dropEffect = 'copy';
            this.setState({ isDragOverRow: { [index]: true } });
        }
    }

    handleRowDragLeave(event, index) {
        event.stopPropagation();
        event.preventDefault();
        this.setState({ isDragOverRow: { [index]: false } });
    }

    handleRowDragDrop(event, row) {
        event.stopPropagation();
        event.preventDefault();
        if (event.dataTransfer.files.length > 0) {
            let file = event.dataTransfer.files[0];
            this.handleFileDrop(file, row);
            this.setState({ isDragOverRow: {} });
        }
    }

    handleFileDrop(file, row) {
        const assetsClient = getAssetsClient();
        //uploading file
        setSnackbarMessage(
            <>
                <Spinner /> Uploading file...
            </>,
            true
        );
        assetsClient
            .mutate({
                mutation: uploadFilesQuery,
                variables: {
                    file: file,
                    publish: true,
                    folderPath: '/documents/funeral/' + this.props.form.getField('ID')
                }
            })
            .then(result => {
                const file = result.data.uploadFile;
                this.onFileUploaded(file, row.fieldName);
                setSnackbarMessage('Success, file uploaded. Save to confirm.', true);
            })
            .catch(error => {
                setSnackbarMessage(
                    'Sorry, the upload failed. Please check the file is valid.',
                    false,
                    null,
                    error.graphQLErrors
                );
            });
    }

    onFileUploaded({ ID, AbsoluteLink, FileName }, fieldName) {
        const { form } = this.props;
        const document = {
            ID,
            AbsoluteLink,
            Name: getFileName(FileName),
            Size: 'Save to confirm'
        };

        form.setField({ [fieldName]: document });
    }
}

const styles = ({ palette }) => ({
    iconContainer: {
        textAlign: 'center'
    },
    uploadButtonContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
    },
    green: {
        color: palette.validation.good
    },
    warning: {
        color: palette.validation.suggested
    },
    error: {
        color: palette.validation.error
    },
    dragRow: {
        backgroundColor: 'white!important'
    }
});

export default compose(withRouter, withStyles(styles))(CertificationTable);
